// src/components/PartnersMarquee.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './PartnersMarquee.css';

function PartnersMarquee() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axios.get('https://api.hospifylink.com/api/partners').then(r => setPartners(r.data)).catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  // Duplicate the list so the loop looks seamless
  const items = [...partners, ...partners];

  return (
    <section className="partners-root">
      <div className="partners-header">
        <h2 className="lca-section-title">Our Trusted Partners</h2>
        <p className="lca-section-sub">Hotels, businesses &amp; brands that trust Hospify Link</p>
      </div>

      <div className="partners-marquee">
        <div className="partners-track">
          {items.map((p, i) => (
            <a
              key={`${p.id}-${i}`}
              href={p.website_url || '#'}
              target="_blank"
              rel="noreferrer"
              className="partners-item"
              title={p.name}
            >
              {p.logo
                ? <img src={p.logo} alt={p.name} loading="lazy" />
                : <span className="partners-item-name">{p.name}</span>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PartnersMarquee;
